const self = {};

self.regex = {
    lastname: "[A-Za-zÀ-ú]+",
    firstname: "[A-Za-zÀ-ú]+",
    name: "[A-Za-zÀ-ú]+\\s+['A-Za-zÀ-ú]+",
    email: "(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])",
    idNumber: "^[0-9]{7,8}$",
    mobilePhone: "^[0-9+-]{12,13}$",
    monthlyIncome: "^[0-9]{1,7}([,.][0-9]{1,7})?$",
};

//TODO Deprecar. No lo saco de acá porque hay que revisar bien en todos los lugares donde se usaba. Lo dejo por si acaso asi no me rompe la build
self.Roles = Object.freeze({
    AGENTE_DE_RIESGO: "AgenteDeRiesgo",
    COMERCIAL: "Comercial",
    AGENCIA: "Agencia",
    OPERADOR: "Operador",
    ADMINISTRADOR: "Administrador",
    INTEGRADOR: "Integrador",
    VENDEDOR: "seller",
    SUPER_ADMINISTRADOR: "SuperAdministrador",
});

//TODO Esto me parece medio "complejo" para mantener porque hay que hacer una paridad entre el front/lambdas. Una cosa que podriamos hacer es un archivo privado en s3 del cual se alimenten ambos?
self.PermissionsPerRole = Object.freeze({
    SUPER_ADMINISTRADOR: [
        "contacts:*",
        "contacts:ViewAllFromWorkspace",
        "contacts:SendWhatsapp",
        "documents:*",
        "tenants:*",
        "iam:*",
        "iam.roles:*",
        "applications:*",
        "workspaces:*",
        "documents.notes:*",
        "documents.biometrics:*",
        "documents.biometrics:ManualValidation",
        "documents:QueryThirdParty",
        "documents:ViewRawData",
        "documents:ViewRawEvents",
        "documents:SendWhatsapp",
        "documents:AssignDocument",
        "documents:ManageAssignations",
        "documents:SelfAssign",
        "documents:ForceAssign",
        "documents:EditAssignedFlow",
        "documents:Export",
        "documents:Import",
        "documents.files:Export",
        "tenants:SetMaintenance",
        "support:RequestHelp",
    ],
    VENDEDOR: [
        // NOTE: Removed permissions (contacts:*, contacts.documents:Create).
        // Contacts module only enabled for specific clients (Fava).
        // These roles have no access to the module in their workspace, so permissions unnecessary.
        "documents:List",
        "documents:Create",
        "documents:SendWhatsapp",
        "documents:ViewOnlyParticipants",
        "documents.notes:Get",
    ],
    ADMINISTRADOR: [
        // NOTE: Removed permissions (contacts:*, contacts:ViewAllFromWorkspace, contacts:SendWhatsapp, contacts.documents:Create).
        // Contacts module only enabled for specific clients (Fava).
        // These roles have no access to the module in their workspace, so permissions unnecessary.
        "documents:Get",
        "documents:List",
        "documents:Update",
        "documents:SendWhatsapp",
        "documents:AssignDocument",
        "documents:ManageAssignations",
        "documents:QueryThirdParty",
        "documents:SelfAssign",
        "documents:ForceAssign",
        "documents:Export",
        "documents.notes:*",
        "documents.biometrics:Create",
        "documents.biometrics:Get",
        "documents.biometrics:Update",
        "documents.biometrics:Delete",
        "documents.biometrics:ManualValidation",
        "documents:DeleteContract",
        "documents:UpdateStatus",
        "documents.files:Export",
        "support:RequestHelp",
        "iam:Get",
        "iam:List",
        "iam:Update",
    ],
    COMERCIAL: [
        // NOTE: Removed permissions (contacts:*, contacts:SendWhatsapp, contacts.documents:Create).
        // Contacts module only enabled for specific clients (Fava).
        // These roles have no access to the module in their workspace, so permissions unnecessary.
        "documents:SendWhatsapp",
        "documents.notes:*",
        "documents.biometrics:Create",
        "documents.biometrics:Get",
        "documents.biometrics:Update",
        "documents.biometrics:Delete",
        "documents:DeleteContract",
        "documents:UpdateStatus",
        "documents:EditAssignedFlow",
        "documents:Get",
        "documents:List",
        "documents:Update",
        "documents:SendWhatsapp",
    ],
    OPERADOR: [
        // NOTE: Removed permissions (contacts:Get, contacts:List, contacts:SendWhatsapp).
        // Contacts module only enabled for specific clients (Fava).
        // These roles have no access to the module in their workspace, so permissions unnecessary.
        "documents:Get",
        "documents:List",
        "documents:SendWhatsapp",
    ],
});

self.DEFAULT_ROLES = [
    {
        _id: "67ae44fd4cb9f4cd44629b1f",
        name: "SuperAdministrador",
        permissions: [...self.PermissionsPerRole.SUPER_ADMINISTRADOR],
        isCustom: false,
        //TODO Mejorar descripcion
        description: "Acceso completo a todos módulos del producto",
    },
    {
        _id: "68e3b4da5c394c27450576a1",
        name: "Administrador",
        permissions: [...self.PermissionsPerRole.ADMINISTRADOR],
        isCustom: false,
        //TODO Mejorar descripcion
        description:
            "Acceso completo a contactos y legajos. Puede gestionar usuarios, realizar validaciones biométricas manuales, administrar notas y eliminar contratos.",
    },
    {
        _id: "67ae44ff4cb9f4cd44629b20",
        name: "Vendedor",
        permissions: [...self.PermissionsPerRole.VENDEDOR],
        isCustom: false,
        //TODO Mejorar descripcion
        description:
            "Permite gestionar contactos, crear y ver sus legajos asignados, enviar WhatsApp yconsultar notas.",
    },
    {
        _id: "690901891e143ebc5a798158",
        name: "Comercial",
        permissions: [...self.PermissionsPerRole.COMERCIAL],
        isCustom: false,
        //TODO Mejorar descripcion
        description:
            "Acceso a contactos y legajos del workspace. Lectura y escritura, gestión de estado del legajo y envío de WhatsApp.",
    },
    {
        _id: "6909019d1e143ebc5a798159",
        name: "Operador",
        permissions: [...self.PermissionsPerRole.OPERADOR],
        isCustom: false,
        //TODO Mejorar descripcion
        description:
            "Acceso a contactos y legajos del workspace. Solo lectura y envio de WhatsApp.",
    },
];

self.DEFAULT_ROLES_FOR_ADMINISTRATOR = [
    {
        _id: "67ae44ff4cb9f4cd44629b20",
        name: "Vendedor",
        permissions: [...self.PermissionsPerRole.VENDEDOR],
        isCustom: false,
        description:
            "Acceso workspace-scoped con algunos recursos tenant-scoped.",
    },
    {
        _id: "6909019d1e143ebc5a798159",
        name: "Operador",
        permissions: [...self.PermissionsPerRole.OPERADOR],
        isCustom: false,
        description:
            "Acceso a contactos y legajos del workspace. Solo lectura y envio de WhatsApp.",
    },
    {
        _id: "690901891e143ebc5a798158",
        name: "Comercial",
        permissions: [...self.PermissionsPerRole.COMERCIAL],
        isCustom: false,
        description:
            "Acceso a contactos y legajos del workspace. Lectura y escritura, gestión de estado del legajo y envío de WhatsApp.",
    },
];

// Mapa completo de permisos organizados por módulo.
// NOTE: <module:*> permissions were dropped to enforce granular access control.
// Can be added back in the future if needed, but not currently in the roadmap.
self.ModulePermissions = Object.freeze({
    documents: [
        { value: "documents:List", label: "Acceder a sección de legajos" },
        {
            value: "documents:Get",
            label: "Ver detalle de legajo",
            tooltip:
                "Abrir el registro individual de un legajo y acceder a sus tabs de información",
        },
        { value: "documents:Create", label: "Crear legajos" },
        // NOTE: documents:Delete removed — only superadmins can delete legajos.
        // Backend enforces deletion via specific roleId check, so this permission should not be assigned to other roles.
        {
            value: "documents:Update",
            label: "Editar legajos",
            tooltip: "Modificar y eliminar información del legajo",
        },
        {
            value: "documents:UpdateStatus",
            label: "Editar estado de gestión del legajo",
            tooltip:
                "Cambiar únicamente el estado de gestión del legajo, sin afectar otros datos",
        },
        { value: "documents:AssignDocument", label: "Asignar legajos" },
        {
            value: "documents:SelfAssign",
            label: "Auto-asignarse legajos",
            tooltip:
                "Asignarse y desasignarse de los legajos, incluso si el legajo ya está asignado a otro usuario",
        },
        {
            value: "documents:ManageAssignations",
            label: "Asignar legajos a otros usuarios",
            tooltip:
                "Asignar legajos a los otros usuarios de ese flujo, incluso si el legajo ya se encontraba asignado",
        },
        {
            value: "documents:ViewOnlyAssignations",
            label: "Ver solo legajos asignados",
            tooltip:
                "Solo visualizar los legajos que se encuentran asignados a este usuario, sin poder ver el resto de legajos del flujo",
        },
        {
            value: "documents:SendWhatsapp",
            label: "Enviar WhatsApp al cliente",
            tooltip:
                "Enviar un WhatsApp al cliente desde el detalle del legajo",
        },
        {
            value: "documents:DeleteContract",
            label: "Eliminar Firma del legajo",
        },
        {
            value: "documents:ViewRawData",
            label: "Ver JSON del legajo",
            tooltip:
                "Visualizar toda la información del legajo en formato JSON",
        },
        { value: "documents:ViewRawEvents", label: "Ver eventos del legajo" },
        {
            value: "documents:QueryThirdParty",
            label: "Consultar servicios del legajo",
        },
        {
            value: "documents.files:Export",
            label: "Exportar PDF/Archivos del legajo",
        },
        {
            value: "documents.files:ExportFilesZip",
            label: "Exportar ZIP con todos los archivos del legajo",
        },
        {
            value: "documents:Export",
            label: "Exportar listado de legajos",
            tooltip:
                "Exportar un listado de legajos de los flujos que tenga asignados",
        },
        {
            value: "documents:Import",
            label: "Importar listado de legajos",
            tooltip: "Importar un listado de legajos en formato CSV",
        },
        { value: "documents:EditAssignedFlow", label: "Editar flujo asignado" },
        { value: "documents:ForceAssign", label: "Forzar asignación" },
        {
            value: "documents:ViewOnlyParticipants",
            label: "Ver legajos en los que participo",
            tooltip:
                "Visualizar únicamente los legajos en los que figura como participante",
        },
    ],
    "documents.notes": [
        { value: "documents.notes:List", label: "Acceder a seccion de notas" },
        { value: "documents.notes:Get", label: "Acceder a nota" },
        {
            value: "documents.notes:Create",
            label: "Crear notas",
            tooltip:
                "Crear notas en el detalle del legajo para agregar comentarios.",
        },
        {
            value: "documents.notes:Update",
            label: "Actualizar",
            tooltip: "Actualizar una nota existente en el detalle del legajo.",
        },
        {
            value: "documents.notes:Delete",
            label: "Eliminar",
        },
    ],
    "documents.biometrics": [
        {
            value: "documents.biometrics:Get",
            label: "Acceder a imágenes de biometría",
        },
        {
            value: "documents.biometrics:Create",
            label: "Crear",
        },
        {
            value: "documents.biometrics:Update",
            label: "Actualizar imágenes de biometría",
        },
        {
            value: "documents.biometrics:Delete",
            label: "Eliminar imágenes de biometría",
        },
        {
            value: "documents.biometrics:ManualValidation",
            label: "Validación manual de biometría",
        },
    ],
    contacts: [
        {
            value: "contacts:List",
            label: "Acceder a sección de contactos",
            tooltip: "Visualizar todos los contactos creados por el usuario",
        },
        { value: "contacts:Get", label: "Ver datos de contactos" },
        { value: "contacts:Create", label: "Crear contacto" },
        { value: "contacts:Update", label: "Editar contacto" },
        { value: "contacts:Delete", label: "Eliminar contacto" },
        {
            value: "contacts:ViewAllFromWorkspace",
            label: "Ver todos los contactos del workspace",
            tooltip:
                "Visualizar todos los contactos que existen, no solo los creados por este usuario",
        },
        {
            value: "contacts:SendWhatsapp",
            label: "Enviar WhatsApp",
            tooltip: "Visualizar el botón de enviar WhatsApp",
        },
    ],
    "contacts.documents": [
        {
            value: "contacts.documents:Create",
            label: "Crear legajos desde contactos",
        },
    ],
    iam: [
        { value: "iam:List", label: "Acceder a sección de usuarios" },
        {
            value: "iam:Get",
            label: "Ver datos de usuarios",
            tooltip:
                'Ingresar al detalle de un usuario individual desde el botón de editar en la columna "Acciones"',
        },
        {
            value: "iam:Create",
            label: "Crear usuarios",
        },
        {
            value: "iam:Update",
            label: 'Editar los datos de los usuarios ya creados, de forma individual desde el botón de editar en la columna "Acciones".',
        },
    ],
    "iam.roles": [
        { value: "iam.roles:List", label: "Listar roles" },
        { value: "iam.roles:Get", label: "Obtener datos de un rol" },
        { value: "iam.roles:Create", label: "Crear rol" },
        { value: "iam.roles:Update", label: "Actualizar datos de un rol" },
        { value: "iam.roles:Delete", label: "Eliminar un rol" },
    ],
    tenants: [
        { value: "tenants:List", label: "Acceder a seccion de flujos" },
        { value: "tenants:Get", label: "Acceder a flujo" },
        { value: "tenants:Create", label: "Crear flujo" },
        { value: "tenants:Delete", label: "Eliminar flujo" },
        { value: "tenants:Update", label: "Actualizar flujo" },
        {
            value: "tenants:SetMaintenance",
            label: "Establecer modo mantenimiento",
        },
    ],

    applications: [
        {
            value: "applications:List",
            label: "Acceder a seccion de aplicaciones",
        },
        { value: "applications:Get", label: "Acceder a aplicacion" },
        { value: "applications:Create", label: "Crear" },
        { value: "applications:Update", label: "Actualizar" },
        { value: "applications:Delete", label: "Eliminar" },
    ],
    workspaces: [
        { value: "workspaces:List", label: "Acceder a seccion de workspaces" },
        { value: "workspaces:Get", label: "Acceder a workspace" },
        { value: "workspaces:Create", label: "Crear" },
        { value: "workspaces:Update", label: "Actualizar" },
        { value: "workspaces:Delete", label: "Eliminar" },
    ],
    support: [
        {
            value: "support:RequestHelp",
            label: "Visualizar el botón de Soporte",
            tooltip:
                "Permite crear tickets de consulta al equipo de soporte técnico de Digiventures",
        },
    ],
});

self.ModuleLabels = Object.freeze({
    contacts: "Contactos",
    "contacts.documents": "Legajos desde Contactos",
    documents: "Legajos",
    "documents.notes": "Notas del Legajo",
    "documents.biometrics": "Biometría",
    tenants: "Flujos",
    iam: "Usuarios",
    "iam.roles": "Roles",
    applications: "Aplicaciones",
    "applications.webhooks": "Webhooks",
    workspaces: "Workspaces",
    support: "Soporte",
});

// self.Permissions = Object.freeze({
//     EDIT_ASSIGNED_FLOW: "edit-assigned-flow",
//     VIEW_TENANTS_LIST: "view-tenants-list",
// });

//TODO Deprecar. No lo saco de acá porque hay que revisar bien en todos los lugares donde se usaba. Lo dejo por si acaso asi no me rompe la build
self.navigationMap = {
    [self.Roles.AGENTE_DE_RIESGO]: ["Legajos", "Contactos"],
    [self.Roles.COMERCIAL]: ["Legajos"],
    [self.Roles.AGENCIA]: ["Legajos", "Aplicaciones"],
    [self.Roles.OPERADOR]: ["Legajos"],
    [self.Roles.ADMINISTRADOR]: [
        "Legajos",
        "Contactos",
        "Usuarios",
        "Aplicaciones",
    ],
    [self.Roles.INTEGRADOR]: ["Aplicaciones"],
    [self.Roles.VENDEDOR]: ["Legajos", "Contactos"],
    [self.Roles.SUPER_ADMINISTRADOR]: [
        "Tenants",
        "Legajos",
        "Contactos",
        "Capabilities",
        "Usuarios",
        "Aplicaciones",
        "Workspaces",
    ],
};

// //TODO Deprecar. No lo saco de acá porque hay que revisar bien en todos los lugares donde se usaba. Lo dejo por si acaso asi no me rompe la build
// self.permissionMap = {
//     [self.Permissions.EDIT_ASSIGNED_FLOW]: ["Tenants"],
//     [self.Permissions.VIEW_TENANTS_LIST]: ["Tenants"],
// };

self.WorkspaceIds = {
    DPORTENIS: "672e0137aa7946c97181995c",
    ONBOARDING: "62195d46c8b99af141555eb6",
    URPTEST: "68c1bd19d9871bcffd4eec57",
    TIENDA_BNA: "65ef2ed47c7ed338682d12b9",
    RIPLEY_PERU: "62191180f5e6b7e31f84447d",
    FAVACARD: "65526e3196bf49a8e681ec21",
};
//TODO Usar un secret manager para estos valores y unificar con los de auth-platform y backoffice-api
self.modules = Object.freeze({
    contacts: "contacts",
    contactsDocuments: "contacts.documents",
    documentFiles: "documents.files",
    documents: "documents",
    documentsContracts: "documents.contracts",
    documentNotes: "documents.notes",
    biometrics: "documents.biometrics",
    documentsStatus: "documents.status",
    tenants: "tenants",
    iam: "iam",
    iamRoles: "iam.roles",
    applications: "applications",
    workspaces: "workspaces",
    capabilities: "capabilities",
    support: "support",
});

//TODO Usar un secret manager para estos valores y unificar con los de auth-platform y backoffice-api
self.actions = Object.freeze({
    CREATE: "Create",
    LIST: "List",
    GET: "Get",
    UPDATE: "Update",
    DELETE: "Delete",
    SELF_ASSIGN: "SelfAssign",
    MANAGE_ASSIGNATIONS: "ManageAssignations",
    ASSIGN_DOCUMENT: "AssignDocument",
    FORCE_ASSIGN: "ForceAssign",
    FORCE_ASSIGNATIONS: "ForceAssignations",
    EDIT_ASSIGNED_FLOW: "EditAssignedFlow",
    VIEW_ONLY_ASSIGNATIONS: "ViewOnlyAssignations", //TODO Mejorar El Nombre a algo que diferencie
    VIEW_ONLY_PARTICIPANTS: "ViewOnlyParticipants", //TODO Mejorar el nombre a algo que diferencie
    VIEW_ALL_FROM_WORKSPACE: "ViewAllFromWorkspace",
    EXPORT_DOCUMENT: "Export",
    IMPORT_DOCUMENT: "Import",
    QUERY_THIRD_PARTY: "QueryThirdParty",
    VIEW_RAW_DATA: "ViewRawData",
    VIEW_RAW_EVENTS: "ViewRawEvents",
    SEND_WHATSAPP: "SendWhatsapp",
    MANUAL_VALIDATION: "ManualValidation",
    DELETE_CONTRACT: "DeleteContract",
    STATUS_UPDATE: "UpdateStatus",
    SET_MAINTENANCE: "SetMaintenance",
    REQUEST_HELP: "RequestHelp",
    EXPORT_FILES_ZIP: "ExportFilesZip",
});

// Helper functions for working with new ModulePermissions structure
self.getPermissionValues = (module) => {
    const modulePerms = self.ModulePermissions[module];
    if (!modulePerms) return [];
    return modulePerms.map((p) => p.value);
};

self.getAllPermissionValues = () => {
    return Object.values(self.ModulePermissions)
        .flat()
        .map((p) => p.value);
};

//API DE URP, LAMBDAS
self.IAM_API_URL = Object.freeze({
    local: "http://localhost:8080",
    qa: "https://iam-api.qa.digiventures.la",
    staging: "https://iam-api.staging.digiventures.la",
    production: "https://iam-api.production.digiventures.la",
});

self.BACKOFFICE_API_URL = Object.freeze({
    local: "http://localhost:3005",
    qa: "https://onboarding-api-bo-qa.digiventures.la",
    staging: "https://onboarding-api-bo-staging.digiventures.la",
    production: "https://onboarding-api-bo-production.digiventures.la",
});

self.ZIP_LAMBDA_ENV_NAME = Object.freeze({
    prod: "production",
    qa: "qa",
    staging: "staging",
    local: "qa",
});

self.ZIP_LAMBDA_BASE_URL = Object.freeze({
    prod: "external.digiventures.la",
    qa: "external.qa.digiventures.la",
    staging: "external.staging.digiventures.la",
    local: "external.qa.digiventures.la",
});

self.RoleIds = {
    SELLER: "67ae44ff4cb9f4cd44629b20",
    ADMINISTRADOR: "68e3b4da5c394c27450576a1",
    SUPER_ADMINISTRADOR: "67ae44fd4cb9f4cd44629b1f",
    SELLER: "67ae44ff4cb9f4cd44629b20",
};

self.SupportURL = "https://portal.digitech.la/tickets-view";
self.Params = {
    HS_ROLE: "hsrole",
    WORKSPACE_HEADER: "workspace",
};

export const TOOLTIP_DELAY_DURATION = 100;

export const INFO_TOOLTIP_ICON_SIZE = 14;

export const INFO_POPOVER_CLOSE_DELAY_MS = 200;

// El sidebar fijo (72px colapsado / 280px expandido) no cuenta como límite
// para la detección de colisiones de Radix, que solo considera el viewport.
// Este padding evita que tooltips/popovers se rendericen por debajo del sidebar.
// left = 280px del sidebar expandido + 8px de buffer para no pegar el contenido al borde.
export const TOOLTIP_COLLISION_PADDING = Object.freeze({
    top: 8,
    bottom: 8,
    left: 288,
    right: 16,
});

// Largo a partir del cual un valor truncado en tabla (Navegación, Historial de
// Edición) muestra el botón de copiar al portapapeles.
export const COPY_BUTTON_MIN_LENGTH = 40;

// OB-5662: mismo mensaje para todos los proveedores SSO — evita duplicarlo por proveedor.
const SSO_LOGIN_FAILED_MESSAGE =
    "No fue posible iniciar sesión. Contacte con su administrador.";

export const LOGIN_ERROR_MESSAGES = Object.freeze({
    no_workspaces:
        "El usuario no tiene espacios de trabajo asignados. Consulte con su administrador.",
    google_login_failed: SSO_LOGIN_FAILED_MESSAGE,
    microsoft_login_failed: SSO_LOGIN_FAILED_MESSAGE,
});

export const AUTH_METHODS = Object.freeze({
    PASSWORD: "password",
    GOOGLE: "google",
    MICROSOFT: "microsoft",
});

export const AUTH_METHOD_OPTIONS = Object.freeze([
    { value: AUTH_METHODS.PASSWORD, label: "Usuario y contraseña" },
    { value: AUTH_METHODS.GOOGLE, label: "Google" },
    { value: AUTH_METHODS.MICROSOFT, label: "Microsoft" },
]);

export const PASSWORD_POLICY = Object.freeze({
    SPECIAL_CHARS: "!@#$%^&*/?",
    SPECIAL_CHARS_REGEX: /[!@#$%^&*/?]/,
    REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*/?])[A-Za-z\d!@#$%^&*/?]{8,}/,
});

export const regex = self.regex;
export const Roles = self.Roles;
// export const Permissions = self.Permissions;
export const ModulePermissions = self.ModulePermissions;
export const ModuleLabels = self.ModuleLabels;
export const navigationMap = self.navigationMap;
// export const permissionMap = self.permissionMap;
export const RolePermissions = self.DEFAULT_ROLES;
export const modules = self.modules;
export const actions = self.actions;
export const AdministratorRoles = self.DEFAULT_ROLES_FOR_ADMINISTRATOR;
export const getPermissionValues = self.getPermissionValues;
export const getAllPermissionValues = self.getAllPermissionValues;
export const IAM_API_URL = self.IAM_API_URL;
export const BACKOFFICE_API_URL = self.BACKOFFICE_API_URL;
export const ZIP_LAMBDA_ENV_NAME = self.ZIP_LAMBDA_ENV_NAME;
export const ZIP_LAMBDA_BASE_URL = self.ZIP_LAMBDA_BASE_URL;
// Mapping from workspacePermissions keys to navigation items used in the sidebar. When changing the name in _nav.jsx it needs to match here.
self.PermissionToNavMapping = Object.freeze({
    documents: "Legajos", // documents -> Legajos
    contacts: "Contactos", // contacts -> Contactos
    tenants: "Tenants", // tenants -> Tenants
    iam: "Usuarios", // iam -> Usuarios
    applications: "Aplicaciones", // applications -> Aplicaciones
    workspaces: "Workspaces", // workspaces -> Workspaces
    capabilities: "Capabilities", // capabilities -> Capabilities
});

export const PermissionToNavMapping = self.PermissionToNavMapping;

// OB-5598: this nav item name is matched by string in 3 places (_nav.jsx, DefaultLayout.jsx,
// routes.jsx) since it has no module permission of its own (superadmin-only, not in
// PermissionToNavMapping) — a single constant so renaming it can't silently break the match.
self.COUNTRY_CONFIG_NAV_NAME = "Configuración por país";
export const COUNTRY_CONFIG_NAV_NAME = self.COUNTRY_CONFIG_NAV_NAME;

// El moduleId del módulo de validación de contacto — lo que el backend estampa en cada entrada
// de historial y el segmento del path de `/module-config/:moduleId`. Vive acá y no en las
// constantes de la view porque `services/ContactValidationConfigService.js` también lo necesita, y un
// service no puede depender de una view. El valor coincide con el slug que ya usa trazabilidad.
export const CONTACT_VALIDATION_MODULE_ID = "contact-validation";

// The two modes of the "mecanismo dinámico de proveedores" confirmation dialogs —
// turning it on is a simple confirmation, turning it off requires a mandatory reason.
export const MECHANISM_DIALOG_MODE = Object.freeze({
    ENABLE: "enable",
    DISABLE: "disable",
});

// Países soportados por la configuración de proveedores de validación de contacto (OB-5598).
// No se usa `packages/countries` porque ese paquete es para validación de documentos
// de identidad y no incluye Bolivia. Esta lista queda pensada como reusable a futuro
// para otras features que necesiten este mismo set de países.
// Flag emoji (regional indicator codepoints) fall back to plain letters ("AR", "MX"...) on
// systems without a color-emoji font — not reliable enough for a backoffice UI. `flag` below
// is drawn as an SVG (see CountryFlag.jsx) instead, so it renders identically everywhere.
export const CONTACT_VALIDATION_COUNTRIES = [
    {
        code: "AR",
        name: "Argentina",
        flag: {
            direction: "horizontal",
            bands: [
                { color: "#74ACDF" },
                { color: "#FFFFFF" },
                { color: "#74ACDF" },
            ],
        },
    },
    {
        code: "MX",
        name: "México",
        flag: {
            direction: "vertical",
            bands: [
                { color: "#006341" },
                { color: "#FFFFFF" },
                { color: "#CE1126" },
            ],
        },
    },
    {
        code: "CO",
        name: "Colombia",
        flag: {
            direction: "horizontal",
            bands: [
                { color: "#FCD116", weight: 2 },
                { color: "#003893" },
                { color: "#CE1126" },
            ],
        },
    },
    {
        code: "BO",
        name: "Bolivia",
        flag: {
            direction: "horizontal",
            bands: [
                { color: "#D52B1E" },
                { color: "#F9E300" },
                { color: "#007934" },
            ],
        },
    },
    {
        code: "PE",
        name: "Perú",
        flag: {
            direction: "vertical",
            bands: [
                { color: "#D91023" },
                { color: "#FFFFFF" },
                { color: "#D91023" },
            ],
        },
    },
];

export const countryName = (code) =>
    CONTACT_VALIDATION_COUNTRIES.find((country) => country.code === code)
        ?.name || code;

// The app header (Header.scss) is a fixed element at z-index 1000 — a plain z-50 sheet
// overlay/content would render behind it. Shared by every Sheet-based overlay so a future
// one doesn't have to rediscover this the hard way.
export const SHEET_OVERLAY_Z_INDEX_CLASS = "z-[1050]";

// Utility function to check if user has specific permission for a module in current workspace
self.hasWorkspacePermission = (user, currentWorkspace, module, action) => {
    if (!user?.workspacePermissions || !currentWorkspace?._id) {
        return false;
    }

    const workspacePerms = user.workspacePermissions[currentWorkspace._id];
    if (!workspacePerms?.permissions) {
        return false;
    }

    const modulePermissions = workspacePerms.permissions[module];
    if (!Array.isArray(modulePermissions)) {
        return false;
    }

    return modulePermissions.includes(action);
};

export const hasWorkspacePermission = self.hasWorkspacePermission;
export const RolesWithEditorPermission = self.RolesWithEditorPermission;
export const RolesWithManualValidation = self.RolesWithManualValidation;
export const WorkspaceIds = self.WorkspaceIds;
export const RoleIds = self.RoleIds;
export const SupportURL = self.SupportURL;

export const LEGAJO_IMAGE_FIELDS = Object.freeze([
    "idCardFront",
    "idCardBack",
    "photo",
    "payslip",
    "utility",
]);

export const ENVIRONMENT_NAME = Object.freeze({
    QA: "qa",
    STAGING: "staging",
    LOCAL: "local",
    PROD: "prod",
});

export const ENVIRONMENT_HOSTNAME_PART = Object.freeze({
    LOCALHOST: "localhost",
    QA: "qa",
    STAGING: "staging",
});

export const ENV_OVERRIDE_KEY = "ENV_OVERRIDE";

/**
 * OB-5614: hotfix #209 hardcoded full-takeover only for congrats/approved/
 * denied/pending — congratsPrevious/contactUs opted out because their button
 * drives further navigation, and that content is legacy data that predates
 * the `customHtmlReplacesScreen` field. Mirrors the onboarding-frontend table
 * in `apps/onboarding/frontend/helpers/customHtmlDefaults.js` — keep both in
 * sync, they can't share a module across apps.
 */
export const LEGACY_CUSTOM_HTML_TAKEOVER_DEFAULT = Object.freeze({
    congrats: true,
    approved: true,
    denied: true,
    pending: true,
    congratsPrevious: false,
    contactUs: false,
});

export const Params = self.Params;

// Tope por defecto de entradas para una pantalla "instantiable" cuando el
// tenant no configuró instanciable.max (OB-5561).
export const DEFAULT_MAX_INSTANCIABLE_ENTRIES = 50;
